import { Controller } from "@hotwired/stimulus"
import { isMobile } from "../../utils/breakpoints.js"

class Header extends Controller {
  static targets = ["iconBurger", "iconClose", "logo", "button", "svgElementButton", "bellHighlight"]
  static outlets = ["menu"]
  static classHidden = "-hidden"
  static values = {
    isHuge: Boolean,
  }

  connect() {
    if (this.isHugeValue) {
      this.currentScrollPercent = 0
      this.endHeaderHeight = 48
      this.endSvgHeight = 24
      this.endLogoHeight = 2.1
      this.endLogoWidth = 13.7
      this.endButtonHeight = 40
      this.checkScreenWidth()
      window.addEventListener("resize", () => {
        this.checkScreenWidth()
      })
      window.addEventListener("scroll", () => {
        this.onScrollHandle()
      })
    }
  }

  openMenu(event) {
    event.preventDefault()

    if (this.hasMenuOutlet) {
      if (this.menuOutlet.isOpen()) {
        this.menuOutlet.close()
      } else {
        this.menuOutlet.open(this.currentScrollPercent)
      }
    }
  }

  // Called by NavMenu#refreshDependencies
  refreshIconStatus() {
    if (this.hasMenuOutlet && this.menuOutlet.isOpen()) {
      this.iconCloseTarget.classList.remove(Header.classHidden)
      this.iconBurgerTarget.classList.add(Header.classHidden)
    } else {
      this.iconBurgerTarget.classList.remove(Header.classHidden)
      this.iconCloseTarget.classList.add(Header.classHidden)
    }
  }

  // Update scroll percent
  onScrollHandle() {
    let scrollPercent = 1
    if (!isMobile()) {
      scrollPercent = Math.max(0, Math.min(window.scrollY / this.headerHeightXL, 1))
    }
    this.currentScrollPercent = scrollPercent
    this.updateElementsSize()
  }

  // Increase and decrease the header height, logo height and buttons size according to the scroll
  updateElementsSize() {
    // Adjust the header height
    this.element.style.height = this.headerHeightXL - this.currentScrollPercent * (this.headerHeightXL - this.endHeaderHeight) + "px"

    // Adjust the logo height
    const logoCurrentHeight = this.logoHeight + this.currentScrollPercent * (this.endLogoHeight - this.logoHeight)
    const logoCurrentWidth = this.logoWidth + this.currentScrollPercent * (this.endLogoWidth - this.logoWidth)
    this.element.style.setProperty("--logo-shrinking-height", `${logoCurrentHeight}rem`)
    this.element.style.setProperty("--logo-shrinking-width", `${logoCurrentWidth}rem`)

    // Adjust bell highlight position
    if (this.hasBellHighlightTarget) {
      const currentTop = 1.4 + (1 - 1.4) * this.currentScrollPercent
      const currentLeft = 2.8 + (2 - 2.8) * this.currentScrollPercent
      this.bellHighlightTarget.style.top = `${currentTop}rem`
      this.bellHighlightTarget.style.left = `${currentLeft}rem`
    }

    const svgSize = this.svgHeightXL - this.currentScrollPercent * (this.svgHeightXL - this.endSvgHeight)
    const buttonSize = this.buttonHeightXL - this.currentScrollPercent * (this.buttonHeightXL - this.endButtonHeight) + "px"

    // Adjust svg elements height and width
    this.svgElementButtonTargets.forEach((svgElement) => {
      this.element.style.setProperty("--svg-shrinking-size", `${svgSize}px`)
    })
    // Adjust the buttons container height and width
    this.buttonTargets.forEach((button) => {
      this.element.style.setProperty("--button-shrinking-size", buttonSize)
    })
  }

  checkScreenWidth() {
    this.headerHeightXL = 88
    this.svgHeightXL = 32
    this.buttonHeightXL = 52
    this.logoWidth = 22.1
    this.logoHeight = 3.3
    this.onScrollHandle()
  }
}

export { Header }
